var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { AnimationContainer, AnimationFrame, AnimationImg, ErrorNumber, } from './elements';
import { fetchImageBase64, useInterval } from '../../util';
export var Animation = function (_a) {
    var animationSrc = _a.animationSrc, animationFrames = _a.animationFrames, transitionDuration = _a.transitionDuration, errorNumberSrc = _a.errorNumberSrc, imageSrc = _a.imageSrc, _b = _a.imgAfterIdx, imgAfterIdx = _b === void 0 ? -1 : _b, altText = _a.altText, rest = __rest(_a, ["animationSrc", "animationFrames", "transitionDuration", "errorNumberSrc", "imageSrc", "imgAfterIdx", "altText"]);
    var _c = useState({
        frames: [],
        image: null,
        didLoad: false
    }), assets = _c[0], setAssets = _c[1];
    var _d = useState(0), active = _d[0], setActive = _d[1];
    var _e = useInterval(function () {
        setActive(function (curr) { return (curr + 1) % animationFrames; });
    }, transitionDuration), start = _e.start, stop = _e.stop;
    useEffect(function () {
        // Load assets
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, image, frames;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all(__spreadArray([
                            imageSrc && fetchImageBase64(imageSrc)
                        ], __spreadArray([], Array(animationFrames), true).map(function (_, i) { return "".concat(animationSrc, "f").concat(i + 1, ".svg"); })
                            .map(function (url) { return __awaiter(void 0, void 0, void 0, function () {
                            var res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fetch(url)];
                                    case 1:
                                        res = _a.sent();
                                        return [4 /*yield*/, res.text()];
                                    case 2: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }), true))];
                    case 1:
                        _a = _b.sent(), image = _a[0], frames = _a.slice(1);
                        setAssets({
                            didLoad: true,
                            image: image,
                            frames: frames
                        });
                        start();
                        return [2 /*return*/];
                }
            });
        }); })()["catch"](function () {
            // Image failed to load
            // Do nothing
        });
        return stop;
    }, []);
    return (React.createElement(AnimationContainer, __assign({}, rest),
        React.createElement(ErrorNumber, { src: errorNumberSrc, alt: altText }),
        assets.didLoad &&
            assets.frames.map(function (svg, i) { return (React.createElement(AnimationFrame, { key: i, src: "data:image/svg+xml,".concat(svg), alt: "".concat(altText, "-animation"), style: { opacity: active === i ? 1 : 0 } })); }),
        imageSrc && assets.didLoad && (React.createElement(AnimationImg, { role: "presentation", src: assets.image, style: { opacity: active > imgAfterIdx ? 1 : 0 } }))));
};
